import al from './al-AL';
import en from './en-US';
import it from './it-IT';

export default{
    ...al,
    ...en,
    ...it
}